import { colors } from "../../../styles/colors";

/** Per-skin brand colour sources for <LoginBrandActions />.
 *
 *  This is the ONLY file that differs between skins — the component itself is
 *  identical everywhere. Values are used exactly as defined; nothing here is
 *  adjusted at runtime.
 *
 *  Unlike the other skins this one has no per-brand variables.css: its palette
 *  is fixed in src/styles/colors.ts and every whitelabel shares it, so there
 *  are no vars to read and the literals below are what always renders. If this
 *  skin ever gains per-brand theme vars, add their names to the arrays and the
 *  component picks them up with no other change.
 */
export const BRAND_CTA_VARS = {
  gradient: [] as string[],
  accent: [] as string[],
  base: [] as string[],
  fallbackAccent: colors.blue31,
  fallbackBase: colors.blue4,
};
